export class Owner {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly type: string,
  ) {
  }
}